import 'reflect-metadata'
import { define, type, auto, Record, Collection } from 'type-r'
import { openDB, deleteDB } from 'idb';

import Store from './store.js'

import BloodThinnersForm from '#forms/blood_thinners.js'

@define
export default class BloodThinnersFormStore extends Store {
    @(type(BloodThinnersForm).events({"change": "formchange"}).as) bloodThinnersForm: BloodThinnersForm
}

const store = window.store = new BloodThinnersFormStore({ id: "blood-thinners" })
export { store };
